import { ReactNode } from 'react'
import { BlockTypes } from 'enum/block-type.enum'
import { sanitizeHtml } from 'helpers/sanitizeHtml'
import { MandatoryText } from '../MandatoryText'
import styles from './MandatoryBlock.module.scss'

interface Content {
  id: string | number | undefined
  name?: ReactNode
  description?: string
  type: BlockTypes
}

interface MandatoryBlockProps<C extends Content> {
  content: C
  isMandatory: boolean
}

export const MandatoryBlock = <C extends Content>({
  content: { name, id, description, type },
  isMandatory,
}: MandatoryBlockProps<C>) => {
  const blockDescription = description?.replace(/(?:\r\n|\r|\n)/g, '<br>')
  return (
    <div key={type + '-title-' + name + '-' + id} className="mb-3">
      <h2 className={styles.title}> {name}</h2>
      {isMandatory && <MandatoryText />}
      {blockDescription && (
        <div
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(blockDescription) }}
        />
      )}
    </div>
  )
}
